const collectionId = /^[_a-zA-Z][_a-zA-Z0-9-]{0,99}$/;

/** Declaration data only; identity, policy and physical mappings stay server-owned. */
export function readInitialCollectionIds(value) {
  if (
    !Array.isArray(value) ||
    value.length > 100 ||
    value.some(
      (id) => typeof id !== 'string' || !collectionId.test(id) || id === 'demo_products',
    ) ||
    value.some((id, index) => index > 0 && value[index - 1] >= id)
  )
    throw Object.assign(Error('collection_inventory_invalid'), { statusCode: 400 });
  return Object.freeze([...value]);
}

export function isInitialCollectionIds(value) {
  try {
    readInitialCollectionIds(value);
    return true;
  } catch {
    return false;
  }
}

export const sameCollectionIds = (left, right) =>
  left.length === right.length && left.every((id, index) => id === right[index]);
